export const projectTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'principalCompletedAffordable',
    name: 'affordable',
    label: 'Affordable',
  },
  {
    id: 'principalCompletedWorkForce',
    name: 'workForce',
    label: 'Work Force',
  },
  {
    id: 'principalCompletedMarketRate',
    name: 'marketRate',
    label: 'Market Rate',
  },
  {
    id: 'principalCompletedSenior',
    name: 'senior',
    label: 'Senior',
  },
  {
    id: 'principalCompletedMixedIncome',
    name: 'mixedIncome',
    label: 'Mixed Income',
  },
  {
    id: 'principalCompletedMixedUse',
    name: 'mixedUse',
    label: 'Mixed Use',
  },
  {
    id: 'principalCompletedCommercialProject',
    name: 'commercialProject',
    label: 'Commercial Project',
  },
];
export const companyRoles: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedLeadSponsor',
    name: 'leadSponsor',
    label: 'Lead Sponsor/Managing Member',
  },
  {
    id: 'companyCompletedCoSponsor',
    name: 'coSponsor',
    label: 'Co-Sponsor',
  },
  {
    id: 'companyCompletedLimitedPartner',
    name: 'limitedPartner',
    label: 'Limited Partner',
  },
  {
    id: 'companyCompletedSourcedOpportunity',
    name: 'sourcedOpportunity',
    label: 'Sourced Opportunity',
  },
  {
    id: 'companyCompletedFullOwner',
    name: 'fullOwner',
    label: 'Full Owner',
  },
];

export const constructionTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'principalCompletedNewConstruction',
    name: 'newConstruction',
    label: 'New Construction',
  },
  {
    id: 'principalCompletedHistoricRenovation',
    name: 'historicRenovation',
    label: 'Historic Renovation',
  },
  {
    id: 'principalCompletedRenovation',
    name: 'renovation',
    label: 'Renovation',
  },
  {
    id: 'principalCompletedAdaptiveReuse',
    name: 'adaptiveReuse',
    label: 'Adaptive Reuse',
  },
  {
    id: 'principalCompletedInplaceRenovation',
    name: 'inPlaceRenovation',
    label: 'In-Place Renovation',
  },
];

export const initialValues: { [key: string]: { [key: string]: any } } = {
  companyName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  projectName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  dateCompleted: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  streetAddress: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  city: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      minLength: 3,
      maxLength: 150,
    },
  },
  state: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      minLength: 3,
      maxLength: 150,
    },
  },
  zipCode: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 5,
      maxLength: 5,
    },
  },
  grossBuildingArea: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  housingUnits: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
      min: 0,
    },
  },
  developmentCost: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
      max: 999999999999999,
    },
  },
  projectTypes: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  constructionTypes: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  companyRole: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  partialOwner: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
      min: 0,
      max: 100,
    },
  },
};
